var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1680,
    height: 830,
    viewBox: "0 0 1680 830",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1680,
    height: 830,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_1399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M913.807 455.947H1010.46V495.265H867.159V293.368H913.807V455.947Z",
    fill: "#6B6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.03 418.294H1151.01V453.624C1144.04 456.282 1130.36 458.941 1117.39 458.941C1075.38 458.941 1061.41 437.616 1061.41 394.31C1061.41 352.981 1074.71 328.66 1116.68 328.66C1140.07 328.66 1153.34 335.999 1164.34 349.994L1193.36 323.333C1175.64 298.064 1144.71 290.406 1115.67 290.406C1050.38 290.38 1016.05 325.992 1016.05 393.965C1016.05 461.6 1047.07 498.268 1115.32 498.268C1146.66 498.268 1177.29 490.291 1193.97 478.6V380.643H1113.03V418.294Z",
    fill: "#6B6C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.525 505.537C812.497 444.565 812.494 345.709 751.519 284.734C690.544 223.759 591.688 223.757 530.717 284.728C469.745 345.699 469.748 444.556 530.723 505.53C591.697 566.505 690.554 566.508 751.525 505.537Z",
    fill: "#A50034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.314 449.087H647.406V329.202H635.609V460.919H647.433V460.84H679.341L679.314 449.087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.893 400.089H679.495V388.328H770.53C770.654 390.606 770.716 392.883 770.716 395.188C770.716 466.006 712.999 523.404 641.818 523.404C570.637 523.404 512.91 466.032 512.91 395.179C512.91 324.326 570.619 266.963 641.809 266.963C643.688 266.963 645.558 267.001 647.419 267.078V278.751C645.558 278.668 643.694 278.627 641.826 278.627C577.125 278.627 524.654 330.814 524.654 395.179C524.654 459.544 577.116 511.74 641.826 511.74C704.756 511.74 756.163 462.363 758.884 400.417L758.893 400.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.752 364.69C597.312 364.673 600.787 363.601 603.739 361.61C606.69 359.62 608.986 356.8 610.336 353.506C611.687 350.212 612.031 346.591 611.326 343.102C610.62 339.612 608.897 336.41 606.374 333.899C603.85 331.388 600.639 329.68 597.146 328.992C593.654 328.304 590.035 328.666 586.748 330.032C583.46 331.399 580.651 333.708 578.675 336.67C576.699 339.631 575.645 343.111 575.645 346.671C575.65 349.043 576.123 351.391 577.036 353.58C577.95 355.77 579.285 357.758 580.966 359.431C582.648 361.104 584.643 362.43 586.836 363.332C589.03 364.235 591.38 364.696 593.752 364.69Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_1399"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 709,
    height: 312.253,
    fill: "white",
    transform: "translate(485 239)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgLogo);
export default __webpack_public_path__ + "static/media/LG Logo.610f66839b1be6f52a5c00720a25f7a3.svg";
export { ForwardRef as ReactComponent };